function get_valid_email(email_address) {
  // This regex is not complete but should handle most email addresses
  // Look for the RFC for the full regex
  const email_regex = /^[-0-9A-Za-z_.+]{1,128}@[-0-9A-Za-z_.]{1,128}\.[a-zA-Z]{1,20}$/
  const matches = email_regex.exec(email_address)
  if (!matches) { return null }

  return email_address.toLowerCase()
}

var badges = [
  {
    "id": "architecture",
    "icon": "🏛️",
    "title": "Architecture badge",
    "description": "For software architecture."
  },
  {
    "id": "automation",
    "icon": "⚙️",
    "title": "Automation badge",
    "description": "For CI/CD."
  },
  {
    "id": "backup",
    "icon": "💾",
    "title": "Backup badge",
    "description": "For backups and data recovery."
  },
  {
    "id": "bug",
    "icon": "🐛",
    "title": "Bug badge",
    "description": "For solving a bug."
  },
  {
    "id": "critical",
    "icon": "🤔",
    "title": "Critical badge",
    "description": "For code reviews."
  },
  {
    "id": "design",
    "icon": "🎨",
    "title": "Design badge",
    "description": "For design and frontend."
  },
  {
    "id": "diamond",
    "icon": "💎",
    "title": "Diamond badge",
    "description": "For quality."
  },
  {
    "id": "documentation",
    "icon": "✍️",
    "title": "Documentation badge",
    "description": "For improving documentation."
  },
  {
    "id": "event",
    "icon": "🎠",
    "title": "Event badge",
    "description": "For organizing an event."
  },
  {
    "id": "food",
    "icon": "🍙",
    "title": "Food badge",
    "description": "For organizing refreshments."
  },
  {
    "id": "governance",
    "icon": "⚖️",
    "title": "Governance badge",
    "description": "For achievements relating to governance."
  },
  {
    "id": "hiring",
    "icon": "💼",
    "title": "Hiring badge",
    "description": "For recruitment."
  },
  {
    "id": "iteration",
    "icon": "🔁",
    "title": "Iteration badge",
    "description": "For improving processes."
  },
  {
    "id": "launch",
    "icon": "🚀",
    "title": "Launch badge",
    "description": "For going live with a product."
  },
  {
    "id": "lit",
    "icon": "🔥",
    "title": "Lit badge",
    "description": "For setting your keyboard on fire."
  },
  {
    "id": "maintainability",
    "icon": "🔧",
    "title": "Maintainability badge",
    "description": "For maintainability."
  },
  {
    "id": "notification",
    "icon": "📟",
    "title": "Notification badge",
    "description": "For improving alerts."
  },
  {
    "id": "observability",
    "icon": "📈",
    "title": "Observability badge",
    "description": "For improving monitoring."
  },
  {
    "id": "packaging",
    "icon": "📦",
    "title": "Packaging badge",
    "description": "For maintaining software packages."
  },
  {
    "id": "performance",
    "icon": "⌛",
    "title": "Performance badge",
    "description": "For improving application performance."
  },
  {
    "id": "promotion",
    "icon": "📢",
    "title": "Promotion badge",
    "description": "For sales and marketing."
  },
  {
    "id": "security",
    "icon": "👩‍💻",
    "title": "Security badge",
    "description": "For cybersecurity."
  },
  {
    "id": "scientist",
    "icon": "🔬",
    "title": "Scientist badge",
    "description": "For solving a complex problem."
  },
  {
    "id": "sherlock",
    "icon": "🕵️",
    "title": "Sherlock badge",
    "description": "For diagnosing bugs."
  },
  {
    "id": "sustainability",
    "icon": "🍃",
    "title": "Sustainability badge",
    "description": "For sustainability."
  },
  {
    "id": "terminator",
    "icon": "🗑️",
    "title": "Terminator badge",
    "description": "For sunsetting applications."
  },
  {
    "id": "testing",
    "icon": "🧪",
    "title": "Testing badge",
    "description": "For testing."
  },
  {
    "id": "uptime",
    "icon": "🛡️",
    "title": "Uptime badge",
    "description": "For uptime of applications."
  },
  {
    "id": "wizard",
    "icon": "🧙",
    "title": "Wizard badge",
    "description": "For work on legacy applications."
  },
  {
    "id": "worker",
    "icon": "⚒️",
    "title": "Worker badge",
    "description": "For exceptional endurance."
  },
  {
    "id": "zen",
    "icon": "🧘",
    "title": "Zen badge",
    "description": "For keeping things simple."
  },
  {
    "id": "beach",
    "icon": "⛱️",
    "title": "Beach badge",
    "description": "For work-life balance."
  },
  {
    "id": "clientfocus",
    "icon": "🛒",
    "title": "Client focus badge",
    "description": "For client focus."
  },
  {
    "id": "collaboration",
    "icon": "🤝",
    "title": "Collaboration badge",
    "description": "For collaboration."
  },
  {
    "id": "columbus",
    "icon": "⛵️",
    "title": "Columbus badge",
    "description": "For exploration and discovery."
  },
  {
    "id": "communication",
    "icon": "📬",
    "title": "Communication badge",
    "description": "For communication."
  },
  {
    "id": "community",
    "icon": "👩‍👩‍👧‍👦",
    "title": "Community badge",
    "description": "For teamwork across the organization."
  },
  {
    "id": "diversity",
    "icon": "🌈",
    "title": "Diversity badge",
    "description": "For supporting diversity."
  },
  {
    "id": "earth",
    "icon": "🌐",
    "title": "Earth badge",
    "description": "For globalization."
  },
  {
    "id": "education",
    "icon": "🎓",
    "title": "Education badge",
    "description": "For teaching."
  },
  {
    "id": "empathy",
    "icon": "🙏",
    "title": "Empathy badge",
    "description": "For empathy."
  },
  {
    "id": "leadership",
    "icon": "⭐",
    "title": "Leadership badge",
    "description": "For taking the lead."
  },
  {
    "id": "mentoring",
    "icon": "🧑‍🤝‍🧑",
    "title": "Mentoring badge",
    "description": "For mentoring a colleague."
  },
  {
    "id": "moon",
    "icon": "🌙",
    "title": "Moon badge",
    "description": "For being available above expectations."
  },
  {
    "id": "navigation",
    "icon": "🗺️",
    "title": "Navigation badge",
    "description": "For navigating a complex organization."
  },
  {
    "id": "peace",
    "icon": "🕊️",
    "title": "Peace badge",
    "description": "For solving a personal conflict."
  },
  {
    "id": "pirate",
    "icon": "🏴‍☠️",
    "title": "Pirate badge",
    "description": "For going your own way."
  },
  {
    "id": "positivity",
    "icon": "☀️",
    "title": "Positivity badge",
    "description": "For a positive attitude."
  },
  {
    "id": "reliability",
    "icon": "🗓️",
    "title": "Reliability badge",
    "description": "For being reliable."
  },
  {
    "id": "speakup",
    "icon": "🗣️",
    "title": "Speak up badge",
    "description": "For speaking up about something."
  },
  {
    "id": "speaker",
    "icon": "🎙️",
    "title": "Speaker badge",
    "description": "For a great presentation."
  }
]

export { badges, get_valid_email }
